import { createBrowserRouter } from 'react-router-dom'
import { defaultRoutes } from './default'

export const routes = createBrowserRouter(defaultRoutes)
